import React from 'react';
import './public/site.css';
import PublicHeader from './public/PublicHeader';
import PublicFooter from './public/PublicFooter';

const Contact: React.FC = () => {
  React.useEffect(() => {
    document.title = 'Liên hệ - Fconnect';
  }, []);
  return (
    <div className="home-page fc-site">
      <PublicHeader lang="vi" />

      {/* Content */}
      <section className="home-container">
        <header className="contact-header">
          <h1>Liên hệ với chúng tôi</h1>
          <p className="header-subtitle">Chúng tôi luôn sẵn sàng hỗ trợ bạn</p>
        </header>
        <div className="contact-content">
          <section className="contact-section">
            <h2>Thông tin liên hệ</h2>
            <div className="contact-info-grid">
              <div className="contact-card">
                <div className="contact-icon">
                  <span>📧</span>
                </div>
                <h3>Email</h3>
                <p><strong>trile@fconnect.vn</strong></p>
                <p>Phản hồi trong vòng 2-4 giờ làm việc</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>📞</span>
                </div>
                <h3>Điện thoại</h3>
                <p><strong>02513684266</strong></p>
                <p>Hỗ trợ trực tiếp 8:00 - 22:00</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>📍</span>
                </div>
                <h3>Địa chỉ</h3>
                <p><strong>CÔNG TY CỔ PHẦN TÀI CHÍNH HIỆP TÍN PHÁT</strong></p>
                <p><strong>11/4C, tổ 15, Kp 6, đường Nguyễn Ái Quốc</strong></p>
                <p>Phường Trấn Biên</p>
                <p>Tp. Đồng Nai, Việt Nam</p>
              </div>

              <div className="contact-card">
                <div className="contact-icon">
                  <span>🕐</span>
                </div>
                <h3>Thời gian làm việc</h3>
                <p><strong>Thứ 2 - Chủ nhật</strong></p>
                <p>8:00 - 22:00</p>
                <p>Hỗ trợ khách hàng 24/7</p>
              </div>
            </div>
          </section>
        </div>
      </section>

      <PublicFooter lang="vi" />
    </div>
  );
};

export default Contact; 